<template>
  <div class="login-block">
    <div class="s-h5 skeleton"></div>
    <div class="s-p skeleton"></div>
    <div class="s-input skeleton"></div>
    <div class="s-underline skeleton"></div>

    <div class="s-input skeleton"></div>
    <div class="s-underline skeleton"></div>

    <div class="s-link-box clearfix">
      <div class="fl s-link skeleton"></div>
      <div class="fr s-link skeleton"></div>
    </div>
   <div class="btn-box">
      <v-button  :disabled="true" :loading="true"></v-button>
    </div>
  </div>
</template>
<script>
import vButton from "./vButton.vue";
export default {
  components: {
    vButton
  }
}
</script>
<style lang="scss" scoped>
@import "./../styles/skeleton.scss";
</style>



// WEBPACK FOOTER //
// src/views/index/components/checkT.vue